module.exports = __webpack_public_path__ + "img/pbms-desktop.e844f538.jpg";